import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import FacilityInfo from "./FacilityInfo/FacilityInfo";

export enum pageMode {
  readMode = "read",
  editMode = "edit",
}

type HospitalMappingProps = {
  currentMode: string;
  facility?: string;
};

const HospitalMapping = ({ currentMode, facility }: HospitalMappingProps) => {

  const setPageCurrentMode = useHospitalMappingStore((state) => state.setPageCurrentMode);

  setPageCurrentMode(currentMode);
  return  <FacilityInfo facility={facility}/>
};

export default HospitalMapping;
